import { request } from './http';
import type { PaginatedResult } from '@/types/api';
import type {
  WebhookInboxItem,
  WebhookInboxDetail,
  WebhookInboxQuery,
} from '@/types/webhook';

export const adminWebhooksApi = {
  list(query?: WebhookInboxQuery) {
    return request<PaginatedResult<WebhookInboxItem>>({
      url: '/admin/webhooks',
      method: 'GET',
      params: query,
    });
  },

  detail(id: string) {
    return request<WebhookInboxDetail>({
      url: `/admin/webhooks/${id}`,
      method: 'GET',
    });
  },

  /** 对失败/挂起的回调记录请求重新进入处理器（幂等保护由后端实现） */
  reprocess(id: string) {
    return request<WebhookInboxItem>({
      url: `/admin/webhooks/${id}/reprocess`,
      method: 'POST',
    });
  },
};
